import { Box, Grid, Typography } from "@mui/material";
import { Item } from "../../styles/common";
import { Table } from "../../common/table/Table";
import React, { useCallback } from "react";
import { ReferralUserFilter, ReferralUserFilterData } from "./ReferralUserFilter";
import { useQuery } from "@apollo/client";
import { FETCH_REFERRAL_ACTIVITY } from "./referral.queries";
import { DownloadCsvButton } from "../../common/DownloadCsvButton";
import { config } from "../../config";

const perPage = config.rowsPerPage;

export const ReferralActivity: React.FC<any> = (): JSX.Element => {
  let variables = React.useRef<any>({
    "pagination": {
      "skip": 0,
      "take": perPage
    },
    filter: {
      fieldFilter: {
        filters: [],
        operator: 'AND',
      },
    },
  });
  const { data, loading, refetch } = useQuery(FETCH_REFERRAL_ACTIVITY, { variables: variables.current });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(perPage);

  React.useEffect(() => {
    variables.current = {
      ...variables.current,
      pagination: {
        take: rowsPerPage,
        skip: page * rowsPerPage,
      }
    };

    refetch(variables.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, refetch]);

  const onFilter = useCallback((filter: ReferralUserFilterData) => {
    variables.current = {
      ...variables.current,
      filter: {
        fieldFilter: {
          filters: filter.filters,
          operator: filter.operator,
        },
        hasReferred: filter.usersThatHaveReferred,
        hasRecommendedABusiness: filter.usersThatHaveRecommended,
        hasRecommendedSameBusiness: filter.usersThatHaveRecommendedSameBusiness,
        visitedPage: filter.visitedPage,
        referredByUser: filter.referredByUser,
      },
    };
    refetch(variables.current);
  }, [refetch]);

  if (loading || !data.fetchReferralActivity) return <h4>Loading...</h4>;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography sx={{ m: 2 }} variant="h4">Shared Referral Links</Typography>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <ReferralUserFilter onFilter={onFilter} />
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <DownloadCsvButton
              path="user/export-referral-activity-csv"
              filter={{ filter: variables.current.filter }}
            />
            <Table
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              loading={loading}
              columns={[
                { label: 'Username', key: 'username', rowRender: (row) => row.User.username },
                { label: 'First Name', key: 'firstName', textAlign: 'right', rowRender: (row) => row.User.firstName },
                { label: 'Last Name', key: 'lastName', textAlign: 'right', rowRender: (row) => row.User.lastName },
                { label: 'Email', key: 'email', textAlign: 'right', rowRender: (row) => row.User.email },
                { label: 'Created At', key: 'createdAt', textAlign: 'right', rowRender: (row) => new Date(row.createdAt).toLocaleString() },
              ]}
              rows={data.fetchReferralActivity.userActivities}
              total={data.fetchReferralActivity.total}
            />
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
};